module.exports = __webpack_public_path__ + "static/img/pscl.a472c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pscl.png
// module id = TDeu
// module chunks = 0